/*
 *
 * LanguageProvider
 *
 * this component provides the IntlProvider with the default locale and i18n
 * messages (loaded from `app/translations`)
 */

import React from 'react';
import { IntlProvider } from 'react-intl';

import PropTypes from 'prop-types';

import { DEFAULT_LOCALE } from '../../../i18n';

export function LanguageProvider(props) {
  return (
    <IntlProvider
      locale={DEFAULT_LOCALE}
      key={DEFAULT_LOCALE}
      messages={props.messages[DEFAULT_LOCALE]}
      timeZone="America/Sao_Paulo">
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {
  messages: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
};

export default LanguageProvider;
